export const host = () => {
  return process.env.NODE_ENV === "production"
    ? "https://engine.raccoon-ai.io/"
    : "http://localhost:8000/";
};
